import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ShiftCard from "./ShiftElement";

import api from "../../Utils/api";
import EmploymentDetails from "./Employment";
import PersonalElement from "./PersonalElement";
import UserLeaveRequest from "./LeaveRequest";
import Unavailability from "./Unavailability";
import UserShift from "./UserShift";
import UserNewsfeed from "./UserNewsFeed";
import ShiftControl from "./ShiftControl";

const UserProfileDialog = ({ userID, onClose, locations }) => {
  const [activeTab, setActiveTab] = useState("personal");
  const [formData, setFormData] = useState({
    _id: "",
    preferredName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    dateOfBirth: "",
    pronouns: "",
    birthday: "",
    address: "",
    gender: "",

    address: "",
    city: "",
    country: "",
    postcode: "",
    employmentType: "",
    payRates: {},

    workPeriod: {},
    hoursPerPeriod: 0,
    stressProfile: "",
    leaveEntitlements: [],

    locations: {},

    emergencyContactName: "",
    emergencyContactNumber: "",

    payratesID: {},

    twoFactor: false,
  });

  const [shifts, setShifts] = useState([]);
  const [leaves, setLeaves] = useState([]);
  const [unavailabilities, setUnavailabilities] = useState([]);
  const [newsfeeds, setNewsfeeds] = useState([]);

  useEffect(() => {
    if (userID !== "") {
      getUserUserProfileDialog(userID);
      getUserShifts(userID);
      getPostsByUser(userID);
    }
  }, [userID]);

  const getUserUserProfileDialog = async (userID) => {
    const res = await api.get(`/user/${userID}`);
    if (res.data.success) {
      setFormData((prevData) => ({ ...prevData, ...res.data.user }));
    } else {
      toast.error("Failed to fetch user UserProfileDialog");
    }
  };

  const handleApprove = async (id) => {
    const res = await api.post("/leave/approve", {
      id: id,
    });

    if (res.data.success) {
      toast.success(res.data.message);

      getUserShifts(userID);
    } else {
      toast.error(res.data.message);
    }
  };

  const handleDeny = async (id) => {
    const res = await api.post("/leave/deny", {
      id: id,
    });

    if (res.data.success) {
      toast.success(res.data.message);

      getUserShifts(userID);
    } else {
      toast.error(res.data.message);
    }
  };

  const getUserShifts = async (userID) => {
    const currentDate = new Date();

    // Calculate startTime = currentDate - 15 days
    const startDate = new Date(currentDate);
    startDate.setDate(startDate.getDate() - 7);

    // Calculate endTime = currentDate + 15 days
    const endDate = new Date(currentDate);
    endDate.setDate(endDate.getDate() + 7);

    // Format dates as YYYY-MM-DD (if your API expects this format)
    const formatDate = (date) => date.toISOString().split("T")[0];

    const startTime = formatDate(startDate);
    const endTime = formatDate(endDate);

    // Now send in your API request
    let res = await api.post("/schedule/list", {
      userID: userID,
      startTime: startTime,
      endTime: endTime,
    });

    if (res.data.success) {
      setShifts(res.data.schedules);
      setLeaves(res.data.leaves);
      setUnavailabilities(res.data.unavailables);
    }
  };

  const getPostsByUser = async (userID) => {
    const res = await api.get("/newsfeed", {
      userID: userID,
    }); // Fetch posts from the API
    if (res.data.success) {
      // console.log(res.data.newsfeeds);
      setNewsfeeds(res.data.newsfeeds); // Set the fetched posts to the state
    }
  };

  const tabs = [
    { id: "sub", label: "PROFILE" },
    { id: "personal", label: "Personal" },
    { id: "employment", label: "Employment" },
    { id: "sub", label: "SCHEDULING" },
    { id: "shifts", label: "Shifts" },
    { id: "leave", label: "Leave" },
    { id: "unavailable", label: "Unavailability" },
    { id: "sub", label: "ACTIVITY" },
    { id: "newsfeed", label: "News feed" },
  ];
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white relative rounded-lg w-full max-w-6xl  flex mx-30 p-6 shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-4 right-6 text-gray-500 hover:text-gray-800 text-[30px] font-normal"
        >
          &times;
        </button>
        <div className="flex flex-wrap w-full h-[90vh]">
          <ul className="flex justify-center w-[230px] h-full   border-r border-gray-200 inline-block py-5">
            <div className="w-full">
              <div className="w-full flex flex-col justify-center items-center flex-wrap p-4 bg-white rounded-xl space-y-2">
                {/* Avatar Box (Square) */}
                <div className="w-20 h-20 bg-[#f9f9fb] rounded-full overflow-hidden shadow-inner flex items-center justify-center text-white font-bold text-xl">
                  {/* <img
                    src={
                      formData.preferredName ||
                      `https://api.dicebear.com/7.x/initials/svg?seed=${formData.preferredName}`
                    }
                    alt={formData.preferredName}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = `https://api.dicebear.com/7.x/initials/svg?seed=${formData.preferredName}`;
                    }}
                    className="w-full h-full object-cover"
                  /> */}
                  <div className="font-sans text-[40px] text-[black] font-semibold leading-[24px]">
                    {formData.firstName &&
                      formData.firstName.charAt(0).toUpperCase()}
                    {formData.lastName &&
                      formData.lastName.charAt(0).toUpperCase()}
                  </div>
                </div>

                {/* Username */}
                <div className="flex justify-center text-[18px] font-semibold text-gray-800">
                  {formData.firstName}&nbsp; {formData.lastName}
                </div>

                {/* Role */}
                <div className="text-sm text-gray-500">
                  {formData?.deputyAccessLevel?.toUpperCase()}
                </div>
              </div>

              <ShiftControl userID={userID} />

              {tabs.map((tab) => {
                if (tab.id === "sub") {
                  return (
                    <div
                      className="text-gray-400 text-[16px] mt-8 px-3"
                      key={tab.id}
                    >
                      {tab.label}
                    </div>
                  );
                }

                return (
                  <li
                    key={tab.id}
                    className={`tab flex items-center text-[16px] hover:text-[#4c389d] py-4 px-3 cursor-pointer transition-all ${
                      activeTab === tab.id
                        ? "bg-gray-100 text-gray-600 border-r-4 border-gray-500"
                        : "text-slate-900"
                    }`}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    {tab.label}
                  </li>
                );
              })}
            </div>
          </ul>

          <div className="min-w-50vw bg-white px-6 mt-[40px] h-[calc(100%-40px)]  overflow-y-auto flex-1">
            {activeTab === "personal" && (
              <PersonalElement
                formData={{
                  _id: formData._id,
                  firstName: formData.firstName,
                  lastName: formData.lastName,
                  preferredName: formData.preferredName,
                  birthday: formData.birthday,
                  address: formData.address,
                  pronouns: formData.pronouns,
                  email: formData.email,
                  phone: formData.phone,
                }}
              />
            )}

            {activeTab === "shifts" && <UserShift shifts={shifts} />}
            {activeTab === "employment" && (
              <EmploymentDetails
                payRates={formData.payRates}
                employmentType={formData.employmentType}
                payrates={formData.payratesID}
                workPeriod={formData.workPeriod}
                hoursPerPeriod={formData.hoursPerPeriod}
                leaveEntitlements={formData.leaveEntitlements}
                stressProfile={formData.stressProfile}
                primaryLocation={formData.locations?.primaryLocation?.name}
                userID={userID}
                deputyAccessLevel={formData.deputyAccessLevel}
              />
            )}

            {activeTab === "leave" && (
              <UserLeaveRequest
                handleDeny={handleDeny}
                handleApprove={handleApprove}
                leaves={leaves}
              />
            )}
            {activeTab === "unavailable" && (
              <Unavailability
                getSchedule={getUserShifts}
                unavailabilities={unavailabilities}
              />
            )}
            {activeTab === "newsfeed" && <UserNewsfeed newsfeeds={newsfeeds} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileDialog;
